module.exports = __webpack_public_path__ + "be2fa5144ccd713d01c6f92a79150cca.jpg";